import { motion } from "framer-motion";

const AboutPage = () => {
    /*const team = [
        {
          name: "Ayesha Ali",
          role: "Principal",
          image: "/team/ayesha.jpg",
          bio: "Driven by a passion for modern education and holistic growth."
        },
        {
          name: "Rahul Mehta",
          role: "Academic Coordinator",
          image: "/team/rahul.jpg",
          bio: "Believes in nurturing every student’s individual strengths."
        }
      ];*/
  return (
    <section className="bg-white text-[#14213D] py-16 px-6 md:px-20">
        <section className="relative h-[60vh] flex items-center justify-center bg-cover bg-center text-white" style={{ backgroundImage: `url(https://res.cloudinary.com/dkmxvgmxd/image/upload/v1755621362/aboutus-bg_j7kcwb.jpg)` }}>
        <div className="bg-black/50 absolute inset-0"></div>
        <motion.div 
          className="relative z-10 text-center px-4"
          initial={{ opacity: 0, y: 20 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-2">Shaping Young Minds, Building Bright Futures</h1>
          <p className="text-lg md:text-xl">Welcome to Springdales — where curiosity blossoms and dreams take flight.</p>
        </motion.div>
      </section>
      <div className="max-w-5xl mx-auto space-y-16 my-20">
        {/* Who We Are */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold mb-4 text-schoolRed text-rl">Who We Are</h2>
          <p className="text-lg leading-7 text-gray-700 text-lato">
            Founded in <strong>2019</strong>, Springdales The School is a young and ambitious institution committed to shaping future-ready learners. 
            In just a few years, we've seen remarkable growth — more students, dedicated teachers, and inspiring learning environments.
            Every year, we continue to evolve and expand with purpose, bringing fresh opportunities and vibrant energy into our school community.
          </p>
        </motion.div>

        {/* Our Vision */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6}}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold mb-4 text-schoolRed text-rl">Our Vision</h2>
          <p className="text-lg leading-7 text-gray-700 text-lato">
            Our vision is to create a dynamic and inclusive learning environment where students are nurtured to become confident, 
            compassionate, and capable individuals. We aim to inspire curiosity, cultivate values, and empower each learner to reach 
            their highest potential.
          </p>
        </motion.div>

        {/* Core Values (Optional) */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6}}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold mb-8 text-schoolRed text-rl">What We Stand For</h2>
          <div className="grid gap-6 md:grid-cols-3">
            {[
              { title: "Progressive Learning", text: "A modern approach to education blending academics with real-world skills." },
              { title: "Inclusive Culture", text: "We celebrate diversity and ensure every child feels safe and valued." },
              { title: "Holistic Growth", text: "Focusing on intellectual, emotional, and social development." },
            ].map((item, index) => (
              <div key={index} className="bg-[#f6f9fc] rounded-2xl shadow-md">
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2 text-schoolBlue">{item.title}</h3>
                  <p className="text-gray-600 text-lato">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </motion.div>
        {/*<motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h3 className="text-2xl font-semibold text-center mb-10 text-schoolylw">Meet Our Team</h3>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {team.map((member) => (
            <div key={member.name} className="rounded-2xl shadow-md">
              <div className="flex flex-col items-center p-6">
                <img src={member.image} alt={member.name} className="w-24 h-24 rounded-full mb-4 object-cover" />
                <h4 className="text-lg font-medium">{member.name}</h4>
                <p className="text-sm text-gray-500">{member.role}</p>
                <p className="text-center text-sm text-gray-600 mt-2">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </motion.section> */}
      </div>
    </section>
  );
};

export default AboutPage;
